/* Effective display state of a trail: closures/warnings win, otherwise the ground condition. */
export const CONDITION_KEYS = ["unknown", "wet_auto", "wet_verified", "dry_verified"];

export const LABELS = {
    it: {
        warning: "Attenzione", closed: "Chiuso",
        wet_auto: "Bagnato · auto", wet_verified: "Bagnato · verificato", dry_verified: "Asciutto · verificato", unknown: "Condizioni da verificare",
        srcWeather: "da dati pioggia", srcManual: "verifica manuale",
        disclaimer: "Gli aggiornamenti automatici derivano dalle precipitazioni registrate (Open-Meteo) e sono indicativi: non sostituiscono una verifica sul posto.",
        stale: "Dati pioggia non aggiornati da oltre",
        hours: "ore",
        noteAuto: (mm24, mm6) => `Pioggia registrata: ${mm24} mm nelle ultime 24 h${mm6 ? ` (${mm6} mm nelle ultime 6 h)` : ""}. Fondo presumibilmente bagnato.`,
    },
    en: {
        warning: "Warning", closed: "Closed",
        wet_auto: "Wet · auto", wet_verified: "Wet · verified", dry_verified: "Dry · verified", unknown: "Check conditions",
        srcWeather: "from rainfall data", srcManual: "manual check",
        disclaimer: "Automatic updates come from recorded rainfall (Open-Meteo) and are indicative only: they do not replace checking on site.",
        stale: "Rainfall data not updated for over",
        hours: "hours",
        noteAuto: (mm24, mm6) => `Recorded rain: ${mm24} mm in the last 24 h${mm6 ? ` (${mm6} mm in the last 6 h)` : ""}. Ground presumably wet.`,
    },
};

export const THEMES = {
    warning: { text: "text-abnormal-warn", border: "border-abnormal-warn/60", dot: "bg-abnormal-warn", bg: "bg-black/70" },
    closed: { text: "text-abnormal-red", border: "border-abnormal-red/60", dot: "bg-abnormal-red", bg: "bg-black/70" },
    wet_auto: { text: "text-abnormal-warn", border: "border-abnormal-warn/60", dot: "bg-abnormal-warn", bg: "bg-black/70" },
    wet_verified: { text: "text-abnormal-warn", border: "border-abnormal-warn/80", dot: "bg-abnormal-warn", bg: "bg-black/70" },
    dry_verified: { text: "text-abnormal-acid", border: "border-abnormal-acid/60", dot: "bg-abnormal-acid", bg: "bg-black/70" },
    unknown: { text: "text-abnormal-paperDim", border: "border-white/30", dot: "bg-white/50", bg: "bg-black/70" },
};

export function trailStatus(tr, lang = "it") {
    const L = LABELS[lang === "en" ? "en" : "it"];
    const state = tr.state || "open";
    if (state !== "open") {
        return { key: state, label: L[state], theme: THEMES[state], updatedAt: tr.state_updated_at, source: L.srcManual,
            note: (lang === "en" ? tr.state_note_en : tr.state_note) || "" };
    }
    const cond = CONDITION_KEYS.includes(tr.condition) ? tr.condition : "unknown";
    const auto = tr.condition_source === "weather";
    let note = (lang === "en" ? tr.state_note_en : tr.state_note) || "";
    if (cond === "wet_auto") {
        const mm24 = tr.condition_mm_24h ?? (tr.condition_note || "").split(" mm")[0];
        note = L.noteAuto(mm24 || "?", tr.condition_mm_6h || 0);
    }
    return { key: cond, label: L[cond], theme: THEMES[cond],
        source: cond === "unknown" ? null : auto ? L.srcWeather : L.srcManual, note,
        updatedAt: cond === "unknown" ? null : tr.condition_updated_at };
}

export function fmtDateTime(iso, lang = "it") {
    if (!iso) return null;
    return new Date(iso).toLocaleString(lang === "en" ? "en-GB" : "it-IT", { timeZone: "Europe/Rome", day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}
